import React, { useState } from 'react';
import UIStrings from '@/Utils/UIStrings';
import { DialogEnum, useActionDialogContext } from '../../Context/ActionDialogContext';
import { Button, Spinner } from '@/Components/shadcn';

function RejectActions(): React.JSX.Element {
    const { selectedCandidates, showRejectNotification, hideDialog, rejectApplicantsAsync, isRejectLoading } =
        useActionDialogContext();
    const [willSendEmail, setWillSendEmail] = useState(false);

    const closeRejectDialog = () => {
        hideDialog(DialogEnum.Reject);
    };

    return (
        <div className="flex flex-col gap-2.5">
            {selectedCandidates.length > 1 && (
                <div className="text-foreground text-sm">
                    <span>{`${UIStrings.ClickOn} `}</span>
                    <span>{`"${UIStrings.SendRejectionEmail}" `}</span>
                    <span>{`${UIStrings.RejectNote} ${UIStrings.RejectNote2}`}</span>
                </div>
            )}
            <div className="flex flex-row gap-2.5">
                <Button
                    className="w-1/2"
                    size="lg"
                    disabled={isRejectLoading}
                    variant="outline"
                    onClick={async () => {
                        setWillSendEmail(true);
                        await rejectApplicantsAsync(true);
                        closeRejectDialog();
                        showRejectNotification();
                    }}
                >
                    {isRejectLoading && willSendEmail && <Spinner data-icon="inline-start" />}
                    {UIStrings.SendRejectionEmail}
                </Button>
                <Button
                    className="w-1/2"
                    size="lg"
                    disabled={isRejectLoading}
                    variant="destructive"
                    onClick={async () => {
                        await rejectApplicantsAsync(false);
                        closeRejectDialog();
                        showRejectNotification();
                    }}
                >
                    {isRejectLoading && !willSendEmail && <Spinner data-icon="inline-start" />}
                    {UIStrings.MarkAsRejected}
                </Button>
            </div>
        </div>
    );
}

export default RejectActions;
